import React, { useEffect, useState } from 'react';
import { Avatar } from 'antd';
import UserAvatar from 'components/userAvatar';

// Student photo for the course module — only two cases, same as users V2:
//   1. the user's uploaded image (S3 key or full URL) -> that photo
//   2. otherwise -> initials: image null / "" / "default.png", or the photo
//      fails to load (deleted / bad key)
// `baseUrl` is prefixed to S3 keys (e.g. Api._s3_url, or `${IMG_URL}/`).
export const resolveStudentImage = (image, baseUrl) => {
    if (!image) return "";
    const value = String(image).trim();
    if (!value || value === "null" || value === "undefined" || value.includes("default.png")) return "";
    if (value.startsWith("http") || value.startsWith("blob:")) return value;
    return `${baseUrl || ""}${value}`;
};

const StudentPhotoAvatar = ({ name, image, baseUrl, size, shape = "circle" }) => {
    const url = resolveStudentImage(image, baseUrl);
    const [failed, setFailed] = useState(false);

    // A different photo gets a fresh attempt.
    useEffect(() => {
        setFailed(false);
    }, [url]);

    if (!url || failed) {
        return <UserAvatar size={size} shape={shape} name={name} img="" />;
    }
    return (
        <Avatar
            size={size}
            shape={shape}
            src={url}
            onError={() => {
                setFailed(true);
                return false;
            }}
        />
    );
};

export default StudentPhotoAvatar;
